"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _saraivaUi = require("@minha-biblioteca/saraiva-ui");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
var CopyLimitDialog = _ref => {
  var {
    limitDialog,
    setLimitDialog
  } = _ref;
  var HASH = 'copyright-limit';
  var [hash, setHash] = (0, _react.useState)(global.location.hash);
  var [onHashChangeCallback, setOnHashChangeCallback] = (0, _react.useState)();
  (0, _react.useEffect)(() => {
    function onHashChange() {
      if (onHashChangeCallback) {
        onHashChangeCallback();
        setOnHashChangeCallback();
      }
    }
    window.addEventListener('hashchange', onHashChange);
    return () => window.removeEventListener('hashchange', onHashChange);
  }, [onHashChangeCallback]);
  (0, _react.useEffect)(() => {
    function onBackNavigation() {
      if (hash.includes(HASH)) {
        setLimitDialog(false);
      }
      setHash(global.location.hash);
    }
    window.addEventListener('hashchange', onBackNavigation);
    return () => window.removeEventListener('hashchange', onBackNavigation);
  }, [hash, setLimitDialog]);
  (0, _react.useEffect)(() => {
    if (limitDialog) {
      global.location.hash = HASH;
    } else if (global.location.hash.includes(HASH)) {
      window.history.back();
    }
  }, [limitDialog, setLimitDialog]);
  function onClose() {
    setLimitDialog(false);
  }
  return /*#__PURE__*/_react.default.createElement(_saraivaUi.Dialog, {
    open: limitDialog,
    size: "md",
    title: "Limite de c\xF3pia atingido",
    primaryButton: "entendi",
    handleConfirm: onClose,
    confirmWithoutCheck: onClose,
    handleClose: onClose
  }, "Voc\xEA atingiu o limite m\xE1ximo de c\xF3pia deste livro, por tanto, n\xE3o ser\xE1 mais poss\xEDvel copiar trechos ou cita\xE7\xF5es diretas desta obra.");
};
var _default = exports.default = CopyLimitDialog;